module.exports = __webpack_public_path__ + "resources/img/img_secureguard_pm4_m.d4cb13714424052dcb973c56181a3e97.png";